'use client';

import { Button, Icon } from '@chakra-ui/react';
import { MdArrowForwardIos } from 'react-icons/md';

type ProductsGridProps = {
  onClick: () => void;
  direction: 'left' | 'right' | 'up' | 'down';
};

const degreeMap: Record<ProductsGridProps['direction'], number> = {
  right: 0,
  down: 90,
  left: 180,
  up: 270,
};

const ArrowButton = ({ onClick, direction }: ProductsGridProps) => {
  const degree = degreeMap[direction];
  const isHorizontal = direction === 'left' || direction === 'right';

  return (
    <Button
      pos="absolute"
      onClick={onClick}
      top={direction === 'up' ? '10px' : isHorizontal ? '50%' : 'unset'}
      bottom={direction === 'down' ? '10px' : 'unset'}
      left={direction === 'left' ? '8px' : 'unset'}
      right={direction === 'right' ? '8px' : 'unset'}
      transform={isHorizontal ? 'translateY(-50%)' : undefined}
      zIndex="2"
      display="flex"
      justifyContent="center"
      alignItems="center"
      p="0"
      bg="rgba(10,27,43,0.72)"
      w="38px"
      h="38px"
      maxH="38px"
      minH="38px"
      maxW="38px"
      minW="38px"
      borderRadius="full"
      border="1.5px solid rgba(0,176,202,0.4)"
      backdropFilter="blur(10px)"
      boxShadow="0 4px 16px rgba(0,0,0,0.28)"
      transition="all 0.22s cubic-bezier(0.4,0,0.2,1)"
      _hover={{
        bg: '#00B0CA',
        borderColor: '#00B0CA',
        boxShadow: '0 6px 20px rgba(0,176,202,0.4)',
        transform: isHorizontal ? 'translateY(-50%) scale(1.1)' : 'scale(1.1)',
      }}
      _active={{
        bg: '#009AB5',
        transform: isHorizontal ? 'translateY(-50%) scale(0.95)' : 'scale(0.95)',
      }}
    >
      <Icon color="#fff" h="15px" w="15px" transform={`rotate(${degree}deg)`}>
        <MdArrowForwardIos />
      </Icon>
    </Button>
  );
};

export default ArrowButton;
